import {
    WORKTIME_CURRENT_WEEK_DATA,
    WORKTIME_FETCHING_DATA,
    WORKTIME_UPDATE_DATA,
    WORKTIME_ERROR, WORKTIME_POST,
    WORKTIME_HISTORY,
    WORKTIME_ISEMPTY,
    WORKTIME_ADD_NEW_LOG,
    WORKTIME_REMOVE_LOG
} from "../../typesAction";

const INITIAL_STATE = {
    logs: {},
    inProgress: false,
    isEmpty: false,
    errorMessage: null,
    history: {},
};

export default function(state = INITIAL_STATE, action) {
    switch (action.type) {
        case WORKTIME_CURRENT_WEEK_DATA:
            return { ...state, logs: action.payload, inProgress: false };
        case WORKTIME_FETCHING_DATA:
            return { ...state, inProgress: action.payload };
        case WORKTIME_UPDATE_DATA:

            let logs = state.logs;
            logs[action.payload.day][action.payload.index] = action.payload.data;
            return { ...state, logs: logs, inProgress: false };
        case WORKTIME_POST:
            return { ...state, logs: action.payload, inProgress: false };
        case WORKTIME_HISTORY:
            return { ...state, history: action.payload, inProgress: false };
        case WORKTIME_ISEMPTY:
            return { ...state, logs: action.payload, inProgress: false };
        case WORKTIME_ADD_NEW_LOG:
            let newLogs = { ...state.logs };
            newLogs[action.payload].push({});
            return { ...state, logs: newLogs};
        case WORKTIME_REMOVE_LOG:
            let deletedLogs = { ...state.logs };
            deletedLogs[action.payload.currentDayIndex].splice(action.payload.itemIndex, 1);
            return { ...state, logs: deletedLogs};
        case WORKTIME_ERROR:
            return { ...state, errorMessage: action.payload };
        default:
            return state;
    }
}
